var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["shipping/pdp-quickship-icon.j2"] = require( "shipping/pdp-quickship-icon.j2" );
dependencies["shipping/pdp-collection-points-info-icon.j2"] = require( "shipping/pdp-collection-points-info-icon.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/controls/quickship-message.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"quickShipEligible")) {
var t_1;
t_1 = (lineno = 2, colno = 27, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.selectedSku.sku"]));
frame.set("selectedSku", t_1, true);
if(frame.topLevel) {
context.setVariable("selectedSku", t_1);
}
if(frame.topLevel) {
context.addExport("selectedSku", t_1);
}
output += "<div class=\"o-row c-quickship-message\">\n\n        <a href=\"#quickship-info\" class=\"c-quickship-message__link js-launch-quickship-info\">";
if(runtime.contextOrFrameLookup(context, frame, "selectedSku")) {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "selectedSku")),"quickShipEligible")) {
output += "<span class=\"c-quickship-message__truck-icon c-quickship-message__truck-icon--success\">";
env.getTemplate("shipping/pdp-quickship-icon.j2", false, "product/templates/controls/quickship-message.j2", null, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
t_2.render(context.getVariables(), frame, function(t_5,t_3) {
if(t_5) { cb(t_5); return; }
output += t_3
output += "</span>\n\n                    <span class=\"c-quickship-message__text c-quickship-message__text--success\">";
output += runtime.suppressValue((lineno = 16, colno = 97, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["quickship_sku-eligible"])), env.opts.autoescape);
output += "</span>";
})});
}
else {
output += "<span class=\"c-quickship-message__truck-icon\">";
env.getTemplate("shipping/pdp-quickship-icon.j2", false, "product/templates/controls/quickship-message.j2", null, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
t_6.render(context.getVariables(), frame, function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
output += t_7
output += "</span>\n\n                    <span class=\"c-quickship-message__text\">";
output += runtime.suppressValue((lineno = 24, colno = 62, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["quickship_sku-ineligible"])), env.opts.autoescape);
output += "</span>";
})});
}
;
}
else {
output += "<span class=\"c-quickship-message__truck-icon\">";
env.getTemplate("shipping/pdp-quickship-icon.j2", false, "product/templates/controls/quickship-message.j2", null, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
t_10.render(context.getVariables(), frame, function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
output += t_11
output += "</span>\n\n                <span class=\"c-quickship-message__text\">";
output += runtime.suppressValue((lineno = 34, colno = 58, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["quickship_product-eligible"])), env.opts.autoescape);
output += "</span>";
})});
}
output += "<span class=\"c-quickship-message__info-icon\">";
env.getTemplate("shipping/pdp-collection-points-info-icon.j2", false, "product/templates/controls/quickship-message.j2", null, function(t_16,t_14) {
if(t_16) { cb(t_16); return; }
t_14.render(context.getVariables(), frame, function(t_17,t_15) {
if(t_17) { cb(t_17); return; }
output += t_15
output += "</span>\n\n        </a>\n\n    </div>";
})});
}
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/controls/quickship-message.j2"] , dependencies)